import { render, staticRenderFns } from "./pirates.vue?vue&type=template&id=04107e5e&"
import script from "./pirates.vue?vue&type=script&lang=js&"
export * from "./pirates.vue?vue&type=script&lang=js&"
import style0 from "./pirates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports